import { ConfigProvider as VennDSProvider } from 'antd';
import type { Locale } from 'antd/lib/locale';
// The `.js` extension is required: antd 5 ships no `exports` map, so Node's ESM resolver (SSR, and
// the Playwright e2e server) cannot resolve the extensionless specifier that bundlers accept.
import deDE from 'antd/locale/de_DE.js';
import enUS from 'antd/locale/en_US.js';
import { generateAntTheme, generateAntThemeByPrimaryColor, AppPackageId, type AppPackageIdType } from '../styles/ant-theme';

// ...and because those files are CJS, a bundler hands us the Locale directly while Node hands us the
// module namespace. Unwrap so both runtimes get the same object.
const localeOf = (mod: Locale | { default: Locale }): Locale => ('default' in mod ? mod.default : mod);

// antd ships its own copy for DatePicker, Pagination, Table empty state, etc. Apps pass the
// matching entry to VennDSProvider so those strings follow the app locale, not antd's en_US default.
export const antdLocales = { en: localeOf(enUS), de: localeOf(deDE) } as const;

export type AntdLocaleKey = keyof typeof antdLocales;

export { VennDSProvider, generateAntTheme, generateAntThemeByPrimaryColor, AppPackageId };
export type { AppPackageIdType };
